/* global Units */
// TODO: remove

import ApplicationController from '../application_controller'
import { enableElements, disableElements, addSpinner, removeSpinner } from '../../lib/elements_helper'
import * as bootstrap from 'bootstrap'
import '../../lib/units'

class ExportsController extends ApplicationController {
  static targets = ['file_type', 'target_system', 'download', 'send', 'unitId', 'departments', 'month', 'year', 'modal']
  static values = {
    detailed: Boolean
  }

  connect () {
    this.select_boxes()
    this.modal = new bootstrap.Modal(this.modalTarget)

    const myDefaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList
    myDefaultWhiteList.table = []
    myDefaultWhiteList.tr = []
    myDefaultWhiteList.td = []
    myDefaultWhiteList.th = []
    myDefaultWhiteList.tbody = []
    myDefaultWhiteList.thead = []
    $('[data-bs-toggle="popover"]').popover({
      template: '<div class="datev-logs-popover popover w-auto" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    })
  }

  select_boxes (_event) {
    if (this.buttonsConditions()) {
      enableElements(...this.buttonsList())
    } else {
      disableElements(...this.buttonsList())
    }
  }

  buttonsList () {
    const buttons = [this.downloadTarget]
    if (this.hasSendTarget) {
      buttons.push(this.sendTarget)
    }

    return buttons
  }

  clients_confirmation (event) {
    event.preventDefault()
    this.modal.show()
  }

  unitSelected (event) {
    const selectedUnitId = event.target.value
    const url = new URL(`${document.location.origin}/units/departments/groupped.json`)
    url.searchParams.append('unit_ids[]', selectedUnitId)
    fetch(url, { method: 'GET' })
      .then(response => response.json())
      .then(data => {
        Units.populate_departments_select_box('#datev_export_department_ids', data)
      })

    enableElements(
      this.departmentsTarget,
      this.monthTarget,
      this.yearTarget,
      this.file_typeTarget
      // this.target_systemTarget
    )

    const confirmationModal = document.querySelector('[data-content-loader-url-value]')
    const confirmUrl = new URL(confirmationModal.dataset.contentLoaderUrlValue, document.location.origin)
    confirmUrl.searchParams.set('unit_id', selectedUnitId)
    confirmationModal.dataset.contentLoaderUrlValue = confirmUrl
  }

  download_report (_event) {
    const csrfToken = document.querySelector("[name='csrf-token']").content
    addSpinner(this.downloadTarget)
    disableElements(...this.buttonsList())

    fetch(this.selectedFileTypeUrl(),
      {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(this.exportParameters())
      }).then(resp => {
        const header = resp.headers.get('Content-Disposition')
        const filename = header.split(';')[1].split('=')[1]
        resp.blob().then(blob => {
          const a = document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = filename
          a.click()
          a.remove()
          removeSpinner(this.downloadTarget)
          enableElements(...this.buttonsList())
        })
      })
  }

  selectedFileTypeUrl () {
    const option = this.file_typeTarget.options[this.file_typeTarget.selectedIndex]
    return option.dataset.url
  }

  exportParameters () {
    return {
      department_ids: this.selectedDepartments(),
      month: this.monthTarget.value,
      year: this.yearTarget.value,
      file_type: this.file_typeTarget.value,
      // target_system: this.target_systemTarget.value,
      unit_id: this.unitIdTarget.value
    }
  }

  buttonsConditions () {
    return this.detailedValue &&
      this.unitIdTarget.selectedIndex > 0 &&
      this.file_typeTarget.selectedIndex > 0
    // this.target_systemTarget.selectedIndex > 0
  }

  selectedDepartments () {
    return [...this.departmentsTarget.options].filter(option => option.selected)
      .map(option => option.value)
  }
}

export default ExportsController
